import React, { KeyboardEventHandler } from 'react';
import c from 'classnames';
import { ThemeSurface } from '@wix/da-react-context/pkg/constants';
import Surface from '../../../../Surface';
import { ListItemOption } from '../../../../List/ListItem';
import { getDescendentId } from '../utils';
import s from './AutoCompleteMenu.scss';

interface Props {
  menuId: string;
  items: { label: string; value: string }[];
  selectedIndex: number;
  onSelectItem: (item: { label: string; value: string }) => void;
  onKeyDown?: KeyboardEventHandler<HTMLDivElement>;
  className?: string;
}

const AutoCompleteMenu: React.FC<Props> = ({
  menuId,
  items,
  selectedIndex,
  onSelectItem,
  className,
}) => {
  return (
    // Since this is just the menu portion of an autocomplete pattern, we expect the consumer to handle root-level key events
    <Surface className={c(s['root'], className)} role="listbox" type={ThemeSurface.TERTIARY}>
      {items.map((item, index) => (
        <ListItemOption
          id={getDescendentId(menuId, index)}
          key={index}
          label={item.label}
          checked={selectedIndex === index}
          onClick={() => onSelectItem(item)}
          className={s['option']}
        />
      ))}
    </Surface>
  );
};
AutoCompleteMenu.displayName = 'AutoCompleteMenu';

export default AutoCompleteMenu;
